<template>
  <v-dialog
    v-model="dialogNutrientes"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card v-if="dialogNutrientes">
      <v-card-title v-if="(acesso_premium && (!isEmpresa))">
        <v-layout column>
          <span class="headline">{{ strings[idioma].editar_ingrediente }}</span>
          <span style="font-weight: 400;">{{ alimentos_selecionados[indexAlimentoDialog][idioma === 0 ? 'name' : idioma === 1 ? 'name_en' : 'name_es'] }}
          </span>

        </v-layout>
      </v-card-title>
      <v-card-title v-else>
        <v-layout column>
          <span class="headline">{{ alimentos_selecionados[indexAlimentoDialog][idioma === 0 ? 'name' : idioma === 1 ? 'name_en' : 'name_es'] }}
          </span>
        </v-layout>
      </v-card-title>
      <v-card
        :height="calculandoNutrientes ? heightDialog : undefined"
        :max-height="heightDialog"
        style="overflow:auto"
      >
        <v-layout
          v-if="(acesso_premium && (!isEmpresa))"
          pl-3
          column>
          <span>{{ strings[idioma].info_edicao_ingredientes }}</span>
          <span>{{ strings[idioma].alerta_edicao_ingredientes }}</span>
          <span style="font-weight: 400;">* {{ strings[idioma].ingrediente_personalizado }}</span>
        </v-layout>
        <v-list v-if="!calculandoNutrientes">
          <template
            v-for="(ingrediente, index) in ingredientesComAditivos"
          >
            <v-list-tile
              v-if="alimento.nutrientes[ingrediente.id]"
              :key="ingrediente.id"
              :style="nutrienteClick === ingrediente.id ? 'background: grey; color: #fff;': 'background: #fff; color: #000;'"
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex
                    xs7
                    sm8
                    md9
                    @click="nutrienteClick = ingrediente.id">
                    <span style="font-weight: 500;"> {{ Math.abs(parseString(alimento_root.nutrientes[ingrediente.id], idioma) - parseString(alimento_root.nutrientes_originais[ingrediente.id], idioma)) > 0.01 ? '*': '' }} {{ ingrediente[idioma === 0 ? 'exigencia' : idioma === 1 ? 'exigencia_en' : 'exigencia_es'] }} </span>
                  </v-flex>
                  <v-flex
                    style="background: #fff; color: #000"
                    xs5
                    sm4
                    md3>
                    <v-text-field
                      v-if="alimentos_selecionados[indexAlimentoDialog].id !== ID_LEITE_VACA"
                      :suffix="'(' + (ingrediente[idioma === 0 ?'unidade' : idioma === 1 ? 'unidade_en' : 'unidade_es']) + ')'"
                      v-model.lazy="alimento_root.nutrientes[ingrediente.id]"
                      :readonly="!(acesso_premium && (!isEmpresa))"
                      :disabled="!(acesso_premium && (!isEmpresa))"
                      outline
                      class="text-field-table text-field-nutrientes"
                      color="primary"
                      pattern="\d*"
                      inputmode="decimal"
                      @click="nutrienteClick = ingrediente.id"
                      @keypress="val => onlyFloat(val, alimento_root.nutrientes, ingrediente.id)"
                      @change="(val) => {changeIngrediente(ingrediente.id, val, ingrediente.unidade);alimento_root.alterado = true; alterou = true;}"
                    />
                    <v-text-field
                      v-else
                      :suffix="'(' + (ingrediente[idioma === 0 ?'unidade' : idioma === 1 ? 'unidade_en' : 'unidade_es']) + ')'"
                      v-model="alimento_root.nutrientes[ingrediente.id]"
                      :readonly="!(acesso_premium && (!isEmpresa))"
                      :disabled="!(acesso_premium && (!isEmpresa))"
                      outline
                      class="text-field-table text-field-nutrientes"
                      color="primary"
                      pattern="\d*"
                      inputmode="decimal"
                      @click="nutrienteClick = ingrediente.id"
                      @keypress="val => onlyFloat(val, alimento_root.nutrientes, ingrediente.id)"
                      @change="alimento_root.alterado = true; alterou = true;"
                    />

                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider
              v-if="index !== 'Zn'"
              :key="index + '_divider'"
            />
          </template>
        </v-list>
        <v-layout
          v-else
          fill-height
          align-center
          justify-center
          column
        >
          <span style="font-weight: 500; padding: 4px">{{ strings[idioma].recalculando_nutrientes }}</span>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          />
        </v-layout>
      </v-card>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          v-if="acesso_premium && (!isEmpresa) && (alimento.alterado) && !reseted"
          :loading="calculandoNutrientes"
          :disabled="calculandoNutrientes"
          color="primary"
          @click="resetNutrientes(indexAlimentoDialog)"
        >
          <v-icon
            left
            dark>mdi-reload</v-icon>
          {{ strings[idioma].redefinir_nutrientes }}
        </v-btn>
        <v-btn
          v-if="acesso_premium && (!isEmpresa)"
          :disabled="calculandoNutrientes || !alterado"
          :title="strings[idioma].salvar_nutrientes"
          color="success"
          @click="save()"
        >
          <v-icon
            dark>mdi-content-save</v-icon>
        </v-btn>
        <v-btn
          :disabled="calculandoNutrientes"
          :title="strings[idioma].fechar"
          color="error"
          @click="descartar()"
        >
          <v-icon
            dark>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { ID_LEITE_VACA } from '@/utils/types.js'
import { getAlimentos } from '@/utils/utils.js'
import { ENVIAR_ALIMENTO_ADAPTADO } from '../../utils/types'

export default {
  name: 'AlimentosDialog',
  props: {
    alimentos_selecionados: {
      type: Array,
      default: () => []
    },
    ingredientes: {
      type: Object,
      default: () => {}
    },
    dialogNutrientes: {
      type: Boolean,
      default: () => false
    },
    indexAlimentoDialog: {
      type: Number,
      default: () => 0
    },
    ID_LEITE_VACA: {
      type: String,
      default: () => ID_LEITE_VACA
    }
  },
  data () {
    return {
      voltou_original: false,
      reseted: false,
      alimento_root: null,
      alimento: null,
      calculandoNutrientes: false,
      alterado: false,
      pressed: false,
      treeAlimentos: null,
      nutrienteClick: null,
      ingredientesComAditivos: []
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'optionsNumber', 'leiteDeVaca', 'acesso_premium', 'user', 'categorias_alimentos', 'ingredientesCompletos']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    }
  },
  watch: {
    dialogNutrientes (val) {
      // abrindo o editor
      if (val) {
        this.open()
        setTimeout(() => {
          if (!this.user.pecuarista && !this.getAcessoModulo({ user: this.user, modulo: ENVIAR_ALIMENTO_ADAPTADO })) this.sejaPremium()
        }, 500)
      }
    }
  },
  methods: {
    getAditivos () {
      this.$store.dispatch('getAditivos').then(ing => {
        this.ingredientesComAditivos = [...Object.values(this.ingredientesCompletos), ...ing]
      }).catch(_ => {
        this.ingredientesComAditivos = [...Object.values(this.ingredientesCompletos)]
      })
    },
    onlyFloat (val, input, tipo) {
      if (input[tipo] === undefined) input[tipo] = '0'
      this.$onlyFloat(val, input, tipo, this.idioma)
    },
    parseString (valor, idioma) {
      return this.$parseString(valor, idioma)
    },
    deepCopy (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    changeIngrediente (ingrediente, nutriente, unidade) {
      this.alterado = true
      this.reseted = false
      let val = this.parseString(nutriente, this.idioma)
      this.alimento_root.nutrientes[ingrediente] = isNaN(val) ? 0 : this.alimento_root.nutrientes[ingrediente]

      if (unidade === '%') {
        this.alimento_root.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2) ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', '.')
      } else {
        this.alimento_root.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2)
          ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',')
          : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', '.')
      }
      this.$store.commit('setDietaCalculada', false)
      return this.alimento_root.nutrientes[ingrediente]
    },
    sejaPremium () {
      this.$store.commit('openOKModal', {
        title: '',
        msg: this.strings[this.idioma].funcionalidade_exclusiva_premium
      })
    },
    open () {
      const self = this
      self.getAditivos()
      self.nutrienteClick = null
      function evDescarte (evt) {
        evt = evt || window.event
        if (evt.keyCode === 27) {
          self.descartar()
        }
      }
      this.voltou_original = false
      self.alterado = false
      self.alimento = self.deepCopy(self.alimentos_selecionados[self.indexAlimentoDialog])
      self.alimento_root = self.deepCopy(self.alimentos_selecionados[self.indexAlimentoDialog])
      self.isEmpresa = self.alimento.id.split('|')[0] === 'EMP'
      self.alimento.nutrientes_aux = {}
      self.alimento_root.nutrientes_aux = {}
      if (typeof self.alimento.nutrientes === 'string') {
        self.alimento.nutrientes = JSON.parse(self.alimento.nutrientes)
        self.alimento_root.nutrientes = JSON.parse(self.alimento_root.nutrientes)
      }
      for (let nutriente in self.alimento.nutrientes) {
        if (!self.alimento.nutrientes[nutriente]) {
          self.alimento.nutrientes[nutriente] = 0
          self.alimento_root.nutrientes[nutriente] = 0
          self.alimento.nutrientes_aux[nutriente] = 0
          self.alimento_root.nutrientes_aux[nutriente] = 0
        }
        self.alimento_root.nutrientes[nutriente] = parseFloat(self.alimento.nutrientes[nutriente]).toFixed(2).replace('.', self.strings[self.idioma].separador_float)
        self.alimento_root.nutrientes_aux[nutriente] = self.alimento.nutrientes_aux[nutriente]
        self.alimento.nutrientes[nutriente] = parseFloat(self.alimento.nutrientes[nutriente]).toFixed(2).replace('.', self.strings[self.idioma].separador_float)
        self.alimento.nutrientes_aux[nutriente] = self.alimento.nutrientes[nutriente]
      }
      console.log(self.alimento_root.id.startsWith('USR|'))
      document.removeEventListener('keydown', evDescarte)
      document.addEventListener('keydown', evDescarte)
    },
    descartar () {
      if (this.alterado && (this.acesso_premium && (!this.isEmpresa)) && !confirm(this.strings[this.idioma].confirmacao_alteracao_descarte)) return

      this.alimento_root = Object.assign({}, this.alimento)
      for (let nutriente in this.alimento.nutrientes) {
        this.alimento.nutrientes[nutriente] = String(this.alimento.nutrientes_aux[nutriente]).replace(this.strings[this.idioma].separador_float, '.')
      }
      this.$emit('dialogNutrientes', false)
    },
    // fechar com salvamento de alimento
    close () {
      this.reseted = false
      this.$emit('dialogNutrientes', false)
    },
    save () {
      let alimentoUSR = String(this.alimento.id).startsWith('USR|')
      if (!alimentoUSR) {
        if (this.alimento_root.id_alimento_pai !== null) {
          let alChanged = JSON.parse(sessionStorage.getItem('AL_CHANGED'))
          if (alChanged) {
            if (!(alChanged === null || alChanged.length === 0) && alChanged[this.alimento.id_alimento_pai]) alimentoUSR = true
          }
        }
      }
      const atualizaAlimento = () => {
        this.enviaBasePessoal(this.alimento.name).then(r => {
          for (let nutriente in this.alimento.nutrientes) {
            this.alimento_root.nutrientes[nutriente] = (this.idioma === 0 || this.idioma === 2) ? parseFloat(this.alimento_root.nutrientes[nutriente].replace(',', '.')) : this.alimento_root.nutrientes[nutriente]
          }

          this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog]['nutrientes'] = Object.assign({}, this.alimento_root['nutrientes'])
          this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog]['alterado'] = false
          // if (this.alimento_root.alterado) this.$store.commit('setAlimentoAlterado', this.indexAlimentoDialog)
          this.close()
        })
      }
      const salvaAlimentoEFecha = () => {
        this.alterado = false
        for (let nutriente in this.alimento.nutrientes) {
          this.alimento_root.nutrientes[nutriente] = (this.idioma === 0 || this.idioma === 2) ? parseFloat(this.alimento_root.nutrientes[nutriente].replace(',', '.')) : this.alimento_root.nutrientes[nutriente]
        }
        this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog]['nutrientes'] = this.deepCopy(this.alimento_root['nutrientes'])
        this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog]['alterado'] = this.alimento_root.alterado
        if (this.alimento_root.alterado) this.$store.commit('setAlimentoAlterado', this.indexAlimentoDialog)
        this.close()
      }
      const promptSalva = () => {
        let name = null
        do {
          name = window.prompt(this.strings[this.idioma].digite_nome_alimento_complemento_salvar + ':')
        } while (name === undefined || name === '')
        return name
      }

      if (alimentoUSR && this.alterado) {
        atualizaAlimento()
        salvaAlimentoEFecha()
      } else if (this.alterado) {
        if (this.voltou_original) {
          let nomeAntigo = null
          if (this.alimento_root.name_antigo) {
            nomeAntigo = this.alimento_root.name_antigo
          } else {
            nomeAntigo = this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog][this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es']
          }
          this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name = nomeAntigo
          let alChanged = JSON.parse(sessionStorage.getItem('AL_CHANGED'))
          if (alChanged) {
            console.log(alChanged, this.alimento_root.id_alimento_pai, this.alimento_root.id, this.alimento_root)
            if (alChanged[this.alimento_root.id_alimento_pai]) delete alChanged[this.alimento_root.id_alimento_pai]

            sessionStorage.setItem('AL_CHANGED', JSON.stringify(alChanged))
          }
          return salvaAlimentoEFecha()
        }
        this.$confirm(this.$store.state, this.strings[this.idioma].msg_confirma_salva_alimento.format(this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog][this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es'] )).then(r => {
          if (r === 'sim') {
            let name = ''
            let res = promptSalva()
            if (res !== null) {
              salvaAlimentoEFecha()
            } else {
              return this.descartar()
            }
            let nomeAntigo = null
            if (this.alimento_root.name_antigo) {
              nomeAntigo = this.alimento_root.name_antigo
            } else {
              nomeAntigo = this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog][this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es']
            }

            name = nomeAntigo + ' - ' + res
            if (res === null) return this.close()
            console.log(this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name_antigo)
            this.enviaBasePessoal(name, (alimento) => {
              this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name = name
              this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name_en = name
              this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name_es = name
              this.$store.state.app.alimentos_selecionados[this.indexAlimentoDialog].name_antigo = nomeAntigo
              let alimentoIdAlterado = 'USR|' + alimento.id
              let alChanged = JSON.parse(sessionStorage.getItem('AL_CHANGED'))
              if (alChanged === null || alChanged.length === 0) {
                alChanged = {}
              }
              alChanged[this.alimento.id] = alimentoIdAlterado
              sessionStorage.setItem('AL_CHANGED', JSON.stringify(alChanged))
            })
          } else {
            salvaAlimentoEFecha()
          }
        })
      }
    },
    enviaBasePessoal (nome, callback = null, exibeMsg = false) {
      let alimento = this.deepCopy(this.alimento_root)
      this.reseted = false
      alimento.user = this.user
      alimento.id_pessoa = (alimento.id_pessoa) ? alimento.id_pessoa : this.user.id
      let alimentoUSR = String(alimento.id).startsWith('USR|')
      alimento.nome = nome
      alimento.nome_ingles = alimento.nome_espanhol = nome
      alimento.nome_cientifico = ''
      if (!alimentoUSR) {
        alimento.id_alimento_pai = this.alimento.id
      }
      delete alimento.nome_sci
      delete alimento.nutrientes_raw
      alimento.id_tipo = alimento.tipo

      let nutrientes = Object.assign({}, alimento.nutrientes)
      for (let ingredienteID in this.ingredientes) {
        let ingrediente = this.ingredientes[ingredienteID]
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = '0'
        nutrientes[ingrediente.id] = parseFloat(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
      }
      alimento.nutrientes = JSON.stringify(nutrientes)
      delete alimento.tipo_name
      delete alimento.tipo_name
      delete alimento.tipo
      delete alimento.user
      delete alimento.empresa
      delete alimento.id
      if (alimentoUSR) {
        alimento.id = parseInt(this.alimento_root.id.split('|')[1])
      }
      console.log({ alimento })
      return this.axios.post('alimentos/saveAlimento', { alimento: alimento }).then((res) => {
        if (exibeMsg) {
          let msg = this.strings[this.idioma].cadastrado
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
        }
        if (callback !== null) callback(res.data)
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    voltarParaPai () {
      this.alterado = true
      var idAlimentoPai = this.alimento_root.id_alimento_pai
      var alimentoPai = null
      if (!idAlimentoPai) return null
      this.categorias_alimentos.forEach(cat => {
        if (!cat.derivados) return null
        let index = cat.derivados.findIndex(d => d.id === idAlimentoPai)
        if (!index || index < 0) return null
        alimentoPai = cat.derivados[index]
      })
      if (alimentoPai === null) return null
      if (this.alimento_root.name_antigo) {
        this.alimento_root.name = this.alimento_root.name_antigo
      }
      for (let nutriente in this.alimento.nutrientes) {
        this.alimento_root.nutrientes[nutriente] = (this.idioma === 0 || this.idioma === 2) ? parseFloat(alimentoPai.nutrientes_originais[nutriente]).toFixed(2).replace('.', ',') : parseFloat(alimentoPai.nutrientes_originais[nutriente]).toFixed(2)
        this.alimento_root.alterado = false
        this.alimento.alterado = false
      }
      return alimentoPai
    },
    resetNutrientes (index) {
      if (this.alimento_root.id_alimento_pai !== null) {
        this.alimento_root.nutrientes = this.deepCopy(this.alimento_root.nutrientes_raw)
        this.alimento_root.alterado = false
        this.reseted = true
        this.alimento_root.id = this.alimento_root.id_alimento_pai
        let nomeAntigo = null
        if (this.alimento_root.name_antigo) {
          nomeAntigo = this.alimento_root.name_antigo
        } else {
          nomeAntigo = (this.idioma === 0) ? this.alimento.name : this.alimento.name_en
        }
        this.alimento_root.name = nomeAntigo
        this.alterado = true
        this.alimento_root.id_alimento_pai = null
        this.voltou_original = true
        for (let nutriente in this.alimento_root.nutrientes) {
          this.alimento_root.nutrientes[nutriente] = (this.idioma === 0 || this.idioma === 2) ? parseFloat(this.alimento_root.nutrientes[nutriente]).toFixed(2).replace('.', ',') : parseFloat(this.alimento_root.nutrientes[nutriente]).toFixed(2)
          this.alimento_root.nutrientes_aux[nutriente] = this.alimento_root.nutrientes[nutriente]
        }
      } else {
        this.alimento_root.nutrientes = this.deepCopy(this.alimento_root.nutrientes_raw)
        this.alimento_root.alterado = false
        this.alimento_root.id = this.alimento_root.id_alimento_pai
        this.alterado = true
        this.alimento_root.id_alimento_pai = null
        this.voltou_original = true
        for (let nutriente in this.alimento_root.nutrientes) {
          this.alimento_root.nutrientes[nutriente] = (this.idioma === 0 || this.idioma === 2) ? parseFloat(this.alimento_root.nutrientes[nutriente]).toFixed(2).replace('.', ',') : parseFloat(this.alimento_root.nutrientes[nutriente]).toFixed(2)
          this.alimento_root.nutrientes_aux[nutriente] = this.alimento_root.nutrientes[nutriente]
        }
      }
    }
  }
}
</script>
